// Merge one page of a paginated cart fetch into the cart we already hold.
//
// The cart's order packages arrive 5 at a time, so a cart of any size takes at
// least two requests and the LAST one always comes back with an empty page.
// Both the local component state and the shared CustomerContext have to end up
// with the accumulated packages -- when only one of them did, the context cart
// looked empty to everything downstream (cartHasItems -> the review page's
// primary checkout CTA silently disappeared) while the rendered list still
// showed the items, which is why this never looked like a data bug.
//
// Pure so both call sites can share ONE merge rather than each writing their
// own subtly different spread.

export const mergeCartPage = (existingCart, incoming) => {
  if (!incoming) return existingCart;
  if (!existingCart?.orderPackages) return incoming;

  const existingPackages = existingCart.orderPackages;
  const existingIds = existingPackages.map((op) => op.id);
  const incomingPackages = incoming.orderPackages || [];

  // Later pages must not re-add a package we already hold, and an empty page
  // must not erase the ones we do.
  const fresh = incomingPackages.filter((op) => !existingIds.includes(op.id));

  return {
    ...existingCart,
    ...incoming,
    orderPackages: [...existingPackages, ...fresh],
  };
};

export default mergeCartPage;
